import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useDebounce } from '../../../../../core/hooks';

import {
  MaskedInput,
} from './styles';

const MaskedInputComponent = (props) => {
  const {
    value,
    mask,
    onChange,
  } = props;

  const [error, setError] = useState(false);
  useDebounce(() => setError(value.includes('_')), 1000, [value]);

  // Prevent save clip on key enter
  const onKeyDown = (e) => e.keyCode === 13 && e.preventDefault();

  return (
    <MaskedInput
      mask={mask}
      value={value}
      onChange={({ target }) => onChange(target.value)}
      onKeyDown={onKeyDown}
      error={error}
    />
  );
};

MaskedInputComponent.propTypes = {
  value: PropTypes.string.isRequired,
  mask: PropTypes.arrayOf(
    PropTypes.oneOfType(
      [PropTypes.string, PropTypes.instanceOf(RegExp)],
    ),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(MaskedInputComponent);
